import { Box, Stack, useTheme } from "@mui/material";
import Image from "next/image"
import EkhoolImage from "../components/ekhoolImage/ekhoolImage";
import { Resizable } from 're-resizable'
import { useSelector } from "react-redux";
import { de, devices } from '../config/config'
import useDevice from "../hooks/useDevice";

function hexWithOpacity(hex, opacity) {
  if (!hex || typeof hex !== "string" || !hex.startsWith("#")) return `rgba(0,0,0,${opacity})`;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${opacity})`;
}

const CustomImage = ({ item, ...props }) => {

    const { reducer } = useSelector((state) => state)
    const { devices } = reducer;
   
    const { isMobile, isTablet } = useDevice()
   
    const footerInfoComponent = item?.key

    const overlayEffect = item?.props?.overlayEffect ?? "clear";
    const overlayIntensity = Number(item?.props?.overlayIntensity ?? 20) / 100;
    const overlayColor = item?.props?.overlayColor || "#000000";
    const showOverlay = overlayEffect !== "clear";

    const overlayStyle = showOverlay
      ? {
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          ...(overlayEffect === "frosted" && {
            backdropFilter: "blur(8px)",
            WebkitBackdropFilter: "blur(8px)",
            backgroundColor: hexWithOpacity(overlayColor.startsWith("#") ? overlayColor : "#000000", overlayIntensity),
          }),
          ...(overlayEffect === "faded" && {
            backgroundColor: hexWithOpacity(overlayColor.startsWith("#") ? overlayColor : "#000000", overlayIntensity),
          }),
        }
      : null;

    return (
        <Box 
            {...props} 
            style={{
                ...item.style,

                // width: item?.style?.width || 320,
                // height: item?.style?.height || 200
               
                width: (isMobile && footerInfoComponent != "footerInfo2" ) ? "100%" : item?.style?.width || '100%',
                height: isMobile ? "" : item?.style?.height || '100%',
                position: 'relative'

                // width: isTablet ? 420 : item?.style?.width,
                // height: isTablet ? 380 : item?.style?.height,
            }}
        >
            <EkhoolImage layout={'fill'} src={item?.src} objectFit={isMobile?"contain":"contain"} {...props} />
            {showOverlay && <Box aria-hidden style={overlayStyle} />}
        </Box>
    )
};

export default CustomImage;